import { render, staticRenderFns } from "./SingleIndicator.vue?vue&type=template&id=8f0514ce&scoped=true"
import script from "./SingleIndicator.vue?vue&type=script&lang=js"
export * from "./SingleIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0514ce",
  null
  
)

export default component.exports